import { render, staticRenderFns } from "./Index-v8.vue?vue&type=template&id=5837ca1e&scoped=true"
import script from "./Index-v8.vue?vue&type=script&lang=js"
export * from "./Index-v8.vue?vue&type=script&lang=js"
import style0 from "./Index-v8.vue?vue&type=style&index=0&id=5837ca1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5837ca1e",
  null
  
)

export default component.exports